import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

// 廣告到達頁降級畫面：當頁面資料取得失敗時，於「原網址」直接回 200 呈現此頁，
// 避免回 4xx/5xx（被 Google 判「到達網頁無效」）或跨網址轉址（關聯性存疑）。
// 刻意不依賴任何 API / Redux / SWR，確保它本身不會再失敗。
const LandingFallback = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
        py: 8,
        gap: 3,
      }}
    >
      <Typography variant="headlineMedium" component="h1" color="textPrimary">
        信義居家
      </Typography>
      <Typography variant="titleMedium" component="p" color="textPrimary">
        頁面內容整理中
      </Typography>
      <Typography
        variant="paraBodyMedium"
        component="p"
        color="textSecondary"
        sx={{ maxWidth: 480 }}
      >
        很抱歉，此頁目前暫時無法顯示，請稍後再試。您也可以先前往首頁瀏覽其他居家服務。
      </Typography>
      <Button variant="contained" href="/" component="a">
        回到首頁
      </Button>
    </Box>
  )
}

export default LandingFallback
